function initMavivaCustomizer() {
  const sections = document.querySelectorAll('.maviva-customizer-section');
  
  sections.forEach(section => {
    try {
      const dataEl = section.querySelector('.mockup-data-element');
      if (!dataEl) return;

      let basePrice = parseFloat(dataEl.dataset.basePrice) || 0;

      const whiteImages = {
        front: dataEl.dataset.whiteFront,
        back: dataEl.dataset.whiteBack,
        sleeve_l: dataEl.dataset.whiteSleevel,
        sleeve_r: dataEl.dataset.whiteSleever
      };

      const blackImages = {
        front: dataEl.dataset.blackFront,
        back: dataEl.dataset.blackBack,
        sleeve_l: dataEl.dataset.blackSleevel,
        sleeve_r: dataEl.dataset.blackSleever
      };

      let currentImages = whiteImages;

      const defaultConfigs = {
        front: {
          top: dataEl.dataset.frontTop,
          left: dataEl.dataset.frontLeft,
          width: dataEl.dataset.frontWidth,
          height: dataEl.dataset.frontHeight
        },
        back: {
          top: dataEl.dataset.backTop,
          left: dataEl.dataset.backLeft,
          width: dataEl.dataset.backWidth,
          height: dataEl.dataset.backHeight
        },
        sleeve_l: {
          top: dataEl.dataset.sleevelTop,
          left: dataEl.dataset.sleevelLeft,
          width: dataEl.dataset.sleevelWidth,
          height: dataEl.dataset.sleevelHeight
        },
        sleeve_r: {
          top: dataEl.dataset.sleeverTop,
          left: dataEl.dataset.sleeverLeft,
          width: dataEl.dataset.sleeverWidth,
          height: dataEl.dataset.sleeverHeight
        }
      };

      const areaConfigs = Array.from(
        dataEl.querySelectorAll('.mockup-area-config')
      ).map(el => ({
        id: el.dataset.id,
        side: el.dataset.side,
        name: el.dataset.name,
        cm: el.dataset.cm,
        surcharge: parseFloat(el.dataset.surcharge) || 0,
        top: el.dataset.top,
        left: el.dataset.left,
        width: el.dataset.width,
        height: el.dataset.height
      }));

      const baseImg = section.querySelector('.mockup-base-img');
      const printArea = section.querySelector('.mockup-print-area');
      const uploadedImgPreview = section.querySelector('.mockup-uploaded-img');

      const viewBtns = Array.from(
        section.querySelectorAll('.view-btn')
      );

      const colorBtns = Array.from(
        section.querySelectorAll('.maviva-color-btn')
      );

      const priceDisplay = section.querySelector('.js-dynamic-price');

      const sizeSelectorStepBox = section.querySelector('#size-step-box');
      const sizeSelectorContainer = section.querySelector(
        '.size-selector-container'
      );

      const dropzone = section.querySelector('.cust-dropzone');
      const dropzoneText = section.querySelector('.dropzone-text');
      const dropzoneIcon = section.querySelector('.dropzone-icon');
      const dropzonePreview = section.querySelector('.dropzone-preview-img');
      const removeBtn = section.querySelector('.cust-remove-img');
      const sideLabelText = section.querySelector('.current-side-text');

      const custForm = section.querySelector('.cust-form');
      const submitBtn = section.querySelector('.cust-submit');

      /* =====================================================
         VARIANTI SHOPIFY: COLORE + TAGLIA
         ===================================================== */

      const variantIdInput = section.querySelector('.hidden-variant-id');
      const variantJsonEl = section.querySelector('.maviva-variant-json');

      const productSizeInput = section.querySelector(
        '.hidden-product-size-input'
      );

      const productSizeBtns = Array.from(
        section.querySelectorAll('.maviva-product-size-pill')
      );

      let productVariants = [];

      try {
        productVariants = variantJsonEl
          ? JSON.parse(variantJsonEl.textContent)
          : [];
      } catch (variantParseError) {
        console.warn(
          'Maviva Customizer: impossibile leggere le varianti prodotto.',
          variantParseError
        );
      }

      const colorOptionIndex = variantIdInput
        ? parseInt(variantIdInput.dataset.colorOptionIndex, 10)
        : -1;

      const sizeOptionIndex = variantIdInput
        ? parseInt(variantIdInput.dataset.sizeOptionIndex, 10)
        : -1;

      let selectedVariant = null;

      let selectedProductSize =
        productSizeBtns.length > 0
          ? productSizeBtns[0].dataset.sizeValue
          : '';

      /* =====================================================
         INPUT GRAFICHE
         ===================================================== */

      const fileInputs = {
        front: section.querySelector('.file-input-front'),
        back: section.querySelector('.file-input-back'),
        sleeve_l: section.querySelector('.file-input-sleeve_l'),
        sleeve_r: section.querySelector('.file-input-sleeve_r')
      };

      const sizeInputs = section.querySelectorAll('.hidden-size-input');
      const styleInputs = section.querySelectorAll('.hidden-style-input');
      const colorInput = section.querySelector('.hidden-color-input');

      const extraGraphicsFeeInput = section.querySelector(
        '.hidden-extra-graphics-fee'
      );

      const sizesFeeInput = section.querySelector(
        '.hidden-sizes-fee'
      );

      const alignBtns = Array.from(
        section.querySelectorAll('.maviva-align-btn')
      );

      const alignInputs = section.querySelectorAll(
        '.hidden-align-input'
      );

      let currentView = 'front';
      let currentSizeName = '';
      let currentColor = 'white';

      let savedState = {
        front: {
          areaId: null,
          align: 'center'
        },
        back: {
          areaId: null,
          align: 'center'
        },
        sleeve_l: {
          areaId: null,
          align: 'center'
        },
        sleeve_r: {
          areaId: null,
          align: 'center'
        }
      };

      function formatVal(val) {
        return String(val).includes('%')
          ? val
          : val + '%';
      }

      /* =====================================================
         INFO COLLAPSIBLE MOBILE
         ===================================================== */

      const infoDetails = section.querySelector('#CustInfoDetails');
      const infoSummary = section.querySelector('.cust-info-summary');

      function handleDetailsOpen() {
        if (window.innerWidth > 990) {
          if (infoDetails) {
            infoDetails.setAttribute('open', '');
          }
        } else {
          if (infoDetails) {
            infoDetails.removeAttribute('open');
          }
        }
      }

      window.addEventListener('resize', handleDetailsOpen);
      handleDetailsOpen();

      if (infoSummary) {
        infoSummary.addEventListener('click', function(e) {
          if (window.innerWidth > 990) {
            e.preventDefault();
          }
        });
      }

      /* =====================================================
         ALLINEAMENTO GRAFICA
         ===================================================== */

      function applyAlignment(alignValue) {
        if (!uploadedImgPreview) return;

        const alignMap = {
          top: 'top center',
          bottom: 'bottom center',
          left: 'center left',
          right: 'center right',
          center: 'center center'
        };

        const textMap = {
          top: 'In Alto',
          bottom: 'In Basso',
          left: 'A Sinistra',
          right: 'A Destra',
          center: 'Centro'
        };

        uploadedImgPreview.style.objectPosition =
          alignMap[alignValue] || 'center center';

        alignBtns.forEach(btn => {
          if (btn.dataset.align === alignValue) {
            btn.classList.add('is-active');
          } else {
            btn.classList.remove('is-active');
          }
        });

        savedState[currentView].align = alignValue;

        alignInputs.forEach(input => {
          if (input.dataset.side === currentView) {
            input.value =
              textMap[alignValue] || 'Centro';
          }
        });
      }

      if (alignBtns.length > 0) {
        alignBtns.forEach(btn => {
          btn.addEventListener('click', e => {
            e.preventDefault();

            const alignValue = btn.dataset.align;

            applyAlignment(alignValue);

            if (
              fileInputs[currentView] &&
              fileInputs[currentView].files.length > 0
            ) {
              const stage =
                section.querySelector('.maviva-top-grid');

              if (stage) {
                const stageRect =
                  stage.getBoundingClientRect();

                const offset =
                  window.innerWidth > 990
                    ? 120
                    : 80;

                window.scrollBy({
                  top: stageRect.top - offset,
                  behavior: 'smooth'
                });
              }
            }
          });
        });
      }

      /* =====================================================
         STATO PULSANTE CARRELLO
         ===================================================== */

      function updateCartButtonState() {
        if (!submitBtn) return;

        let hasFile = false;

        [
          'front',
          'back',
          'sleeve_l',
          'sleeve_r'
        ].forEach(side => {
          if (
            fileInputs[side] &&
            fileInputs[side].files.length > 0
          ) {
            hasFile = true;
          }
        });

        const hasValidVariant =
          !variantIdInput ||
          (
            variantIdInput.value &&
            (
              !selectedVariant ||
              selectedVariant.available !== false
            )
          );

        submitBtn.disabled =
          !(hasFile && hasValidVariant);
      }

      /* =====================================================
         FUNZIONI VARIANTI SHOPIFY
         ===================================================== */

      function normalizeOptionValue(value) {
        return String(value || '')
          .trim()
          .toLowerCase();
      }

      function getCurrentColorOptionValue() {
        const activeColorBtn =
          colorBtns.find(btn =>
            btn.classList.contains('is-active')
          );

        if (!activeColorBtn) {
          return '';
        }

        return (
          activeColorBtn.dataset.optionValue ||
          activeColorBtn.getAttribute('aria-label') ||
          ''
        ).trim();
      }

      function variantMatchesCurrentSelection(variant) {
        if (
          !variant ||
          !Array.isArray(variant.options)
        ) {
          return false;
        }

        /* COLORE */

        if (colorOptionIndex >= 0) {
          const currentColorValue =
            normalizeOptionValue(
              getCurrentColorOptionValue()
            );

          const variantColorValue =
            normalizeOptionValue(
              variant.options[colorOptionIndex]
            );

          if (
            currentColorValue &&
            variantColorValue !== currentColorValue
          ) {
            return false;
          }
        }

        /* TAGLIA */

        if (
          sizeOptionIndex >= 0 &&
          selectedProductSize
        ) {
          const variantSizeValue =
            normalizeOptionValue(
              variant.options[sizeOptionIndex]
            );

          if (
            variantSizeValue !==
            normalizeOptionValue(
              selectedProductSize
            )
          ) {
            return false;
          }
        }

        return true;
      }

      /* =====================================================
         DISPONIBILITÀ TAGLIE PER COLORE
         ===================================================== */

      function refreshSizeAvailability() {
        if (
          productSizeBtns.length === 0 ||
          sizeOptionIndex < 0
        ) {
          return;
        }

        const currentColorValue =
          normalizeOptionValue(
            getCurrentColorOptionValue()
          );

        productSizeBtns.forEach(btn => {
          const sizeValue =
            normalizeOptionValue(
              btn.dataset.sizeValue
            );

          const existsAvailableVariant =
            productVariants.some(variant => {
              if (
                !variant ||
                !Array.isArray(variant.options) ||
                variant.available === false
              ) {
                return false;
              }

              /* Controllo colore */

              if (
                colorOptionIndex >= 0 &&
                currentColorValue
              ) {
                if (
                  normalizeOptionValue(
                    variant.options[
                      colorOptionIndex
                    ]
                  ) !== currentColorValue
                ) {
                  return false;
                }
              }

              /* Controllo taglia */

              return (
                normalizeOptionValue(
                  variant.options[
                    sizeOptionIndex
                  ]
                ) === sizeValue
              );
            });

          btn.classList.toggle(
            'is-unavailable',
            !existsAvailableVariant
          );

          btn.disabled =
            !existsAvailableVariant;

          btn.setAttribute(
            'aria-disabled',
            existsAvailableVariant
              ? 'false'
              : 'true'
          );
        });

        /* Se la taglia selezionata non è disponibile
           seleziona automaticamente la prima disponibile */

        const activeBtn =
          productSizeBtns.find(btn =>
            btn.classList.contains('is-active')
          );

        if (
          !activeBtn ||
          activeBtn.disabled
        ) {
          const firstAvailableBtn =
            productSizeBtns.find(
              btn => !btn.disabled
            );

          productSizeBtns.forEach(btn => {
            btn.classList.remove('is-active');

            btn.setAttribute(
              'aria-pressed',
              'false'
            );
          });

          if (firstAvailableBtn) {
            firstAvailableBtn.classList.add(
              'is-active'
            );

            firstAvailableBtn.setAttribute(
              'aria-pressed',
              'true'
            );

            selectedProductSize =
              firstAvailableBtn.dataset.sizeValue;

            if (productSizeInput) {
              productSizeInput.value =
                selectedProductSize;
            }
          }
        }
      }

      /* =====================================================
         AGGIORNA VARIANTE SHOPIFY
         ===================================================== */

      function updateSelectedVariant() {
        refreshSizeAvailability();

        selectedVariant =
          productVariants.find(
            variant =>
              variantMatchesCurrentSelection(
                variant
              ) &&
              variant.available !== false
          ) ||
          productVariants.find(
            variant =>
              variantMatchesCurrentSelection(
                variant
              )
          ) ||
          null;

        /* ID REALE VARIANTE */

        if (variantIdInput) {
          variantIdInput.value =
            selectedVariant
              ? selectedVariant.id
              : '';
        }

        /* PREZZO DELLA VARIANTE */

        if (
          selectedVariant &&
          typeof selectedVariant.price !==
            'undefined'
        ) {
          basePrice =
            Number(selectedVariant.price) /
            100;
        }

        recalculatePrice();
        updateCartButtonState();
      }

      /* =====================================================
         SELEZIONE COLORE
         ===================================================== */

      if (colorBtns.length > 0) {
        colorBtns.forEach(btn => {
          btn.addEventListener(
            'click',
            e => {
              e.preventDefault();

              colorBtns.forEach(b =>
                b.classList.remove(
                  'is-active'
                )
              );

              btn.classList.add(
                'is-active'
              );

              currentColor =
                btn.dataset.color;

              const selectedColorLabel =
                btn.dataset.optionValue ||
                btn.getAttribute(
                  'aria-label'
                ) ||
                (
                  currentColor === 'white'
                    ? 'Bianco'
                    : 'Nero'
                );

              if (colorInput) {
                colorInput.value =
                  selectedColorLabel;
              }

              currentImages =
                currentColor === 'white'
                  ? whiteImages
                  : blackImages;

              if (uploadedImgPreview) {
                uploadedImgPreview.style.mixBlendMode =
                  currentColor === 'black'
                    ? 'screen'
                    : 'multiply';
              }

              updateSelectedVariant();

              setView(currentView);
            }
          );
        });
      }

      /* =====================================================
         SELEZIONE TAGLIA PRODOTTO
         ===================================================== */

      if (productSizeBtns.length > 0) {
        productSizeBtns.forEach(btn => {
          btn.addEventListener(
            'click',
            e => {
              e.preventDefault();

              if (
                btn.disabled ||
                btn.classList.contains(
                  'is-unavailable'
                )
              ) {
                return;
              }

              productSizeBtns.forEach(
                b => {
                  b.classList.remove(
                    'is-active'
                  );

                  b.setAttribute(
                    'aria-pressed',
                    'false'
                  );
                }
              );

              btn.classList.add(
                'is-active'
              );

              btn.setAttribute(
                'aria-pressed',
                'true'
              );

              selectedProductSize =
                btn.dataset.sizeValue || '';

              if (productSizeInput) {
                productSizeInput.value =
                  selectedProductSize;
              }

              updateSelectedVariant();
            }
          );
        });
      }

      /* =====================================================
         CALCOLO PREZZO
         ===================================================== */

      function recalculatePrice() {
        let activeSidesCount = 0;
        let sizeSurchargeTotal = 0;

        [
          'front',
          'back',
          'sleeve_l',
          'sleeve_r'
        ].forEach(side => {
          const input =
            fileInputs[side];

          if (
            input &&
            input.files &&
            input.files.length > 0
          ) {
            activeSidesCount++;

            const areaId =
              savedState[side].areaId;

            const area =
              areaConfigs.find(
                a => a.id === areaId
              );

            if (
              area &&
              area.surcharge > 0
            ) {
              sizeSurchargeTotal +=
                area.surcharge;
            }
          }
        });

        const extraGraphicsFee =
          Math.max(
            0,
            activeSidesCount - 1
          ) * 1.00;

        const finalPrice =
          basePrice +
          extraGraphicsFee +
          sizeSurchargeTotal;

        if (extraGraphicsFeeInput) {
          extraGraphicsFeeInput.value =
            extraGraphicsFee > 0
              ? `+${extraGraphicsFee}€`
              : '0';
        }

        if (sizesFeeInput) {
          sizesFeeInput.value =
            sizeSurchargeTotal > 0
              ? `+${sizeSurchargeTotal}€`
              : '0';
        }

        if (priceDisplay) {
          priceDisplay.innerText =
            '€' +
            finalPrice
              .toFixed(2)
              .replace('.', ',');
        }

        updateCartButtonState();
      }

      /* =====================================================
         DIMENSIONI AREA STAMPA
         ===================================================== */

      function applyMockupDimensions(
        top,
        left,
        width,
        height,
        sizeName
      ) {
        if (!printArea) return;

        printArea.style.display = 'flex';

        printArea.style.top =
          formatVal(top);

        printArea.style.left =
          formatVal(left);

        printArea.style.width =
          formatVal(width);

        printArea.style.height =
          formatVal(height);

        currentSizeName =
          sizeName;

        let viewLabel = 'Lato';

        const activeBtn =
          section.querySelector(
            '.view-btn.is-active'
          );

        if (activeBtn) {
          const label =
            activeBtn.querySelector(
              'span:first-of-type'
            );

          if (label) {
            viewLabel =
              label.innerText.trim();
          }
        }

        if (sideLabelText) {
          if (
            !sizeName ||
            sizeName === 'Standard'
          ) {
            sideLabelText.innerHTML =
              `${viewLabel}`;
          } else {
            sideLabelText.innerHTML =
              `${viewLabel} &rarr; ${sizeName}`;
          }
        }

        sizeInputs.forEach(input => {
          if (
            input.dataset.side ===
            currentView
          ) {
            input.value =
              currentSizeName;
          }
        });

        styleInputs.forEach(input => {
          if (
            input.dataset.side ===
            currentView
          ) {
            input.value =
              `top: ${formatVal(top)}; ` +
              `left: ${formatVal(left)}; ` +
              `width: ${formatVal(width)}; ` +
              `height: ${formatVal(height)};`;
          }
        });

        recalculatePrice();
      }

      /* =====================================================
         CAMBIO LATO MOCKUP
         ===================================================== */

      function setView(viewName) {
        currentView = viewName;

        if (baseImg) {
          baseImg.classList.add(
            'is-switching'
          );

          setTimeout(() => {
            if (
              currentImages[viewName]
            ) {
              baseImg.src =
                currentImages[viewName];
            }

            baseImg.classList.remove(
              'is-switching'
            );
          }, 150);
        }

        const availableAreas =
          areaConfigs.filter(
            a => a.side === viewName
          );

        if (
          availableAreas.length > 0 &&
          sizeSelectorStepBox &&
          sizeSelectorContainer
        ) {
          sizeSelectorStepBox.style.display =
            'block';

          sizeSelectorContainer.innerHTML =
            '';

          let areaToSelect =
            availableAreas[0];

          if (
            savedState[viewName] &&
            savedState[viewName].areaId
          ) {
            const found =
              availableAreas.find(
                a =>
                  a.id ===
                  savedState[
                    viewName
                  ].areaId
              );

            if (found) {
              areaToSelect = found;
            }
          }

          availableAreas.forEach(area => {
            const wrapper =
              document.createElement(
                'div'
              );

            wrapper.className =
              'size-pill-wrapper';

            const btn =
              document.createElement(
                'button'
              );

            btn.type = 'button';

            btn.className =
              `maviva-pill size-btn ${
                area.id ===
                areaToSelect.id
                  ? 'is-active'
                  : ''
              }`;

            const supplementText =
              area.surcharge > 0
                ? ` (+${area.surcharge}€)`
                : '';

            btn.innerText =
              area.name +
              supplementText;

            if (
              area.surcharge > 0
            ) {
              btn.classList.add(
                'is-premium-size'
              );
            }

            btn.addEventListener(
              'click',
              e => {
                e.preventDefault();

                sizeSelectorContainer
                  .querySelectorAll(
                    '.size-btn'
                  )
                  .forEach(b =>
                    b.classList.remove(
                      'is-active'
                    )
                  );

                btn.classList.add(
                  'is-active'
                );

                savedState[
                  viewName
                ].areaId =
                  area.id;

                applyMockupDimensions(
                  area.top,
                  area.left,
                  area.width,
                  area.height,
                  area.name
                );

                if (
                  fileInputs[
                    currentView
                  ] &&
                  fileInputs[
                    currentView
                  ].files.length > 0
                ) {
                  const stage =
                    section.querySelector(
                      '.maviva-top-grid'
                    );

                  if (stage) {
                    const stageRect =
                      stage.getBoundingClientRect();

                    const offset =
                      window.innerWidth >
                      990
                        ? 120
                        : 80;

                    window.scrollBy({
                      top:
                        stageRect.top -
                        offset,
                      behavior:
                        'smooth'
                    });
                  }
                }
              }
            );

            wrapper.appendChild(btn);

            if (area.cm) {
              const cmText =
                document.createElement(
                  'span'
                );

              cmText.className =
                'size-cm-text';

              if (
                area.surcharge > 0
              ) {
                cmText.classList.add(
                  'is-premium-text'
                );
              }

              cmText.innerText =
                area.cm;

              wrapper.appendChild(
                cmText
              );
            }

            sizeSelectorContainer.appendChild(
              wrapper
            );
          });

          savedState[
            viewName
          ].areaId =
            areaToSelect.id;

          applyMockupDimensions(
            areaToSelect.top,
            areaToSelect.left,
            areaToSelect.width,
            areaToSelect.height,
            areaToSelect.name
          );
        } else {
          if (sizeSelectorStepBox) {
            sizeSelectorStepBox.style.display =
              'none';
          }

          const def =
            defaultConfigs[viewName];

          if (def) {
            applyMockupDimensions(
              def.top,
              def.left,
              def.width,
              def.height,
              'Standard'
            );
          }
        }

        applyAlignment(
          savedState[viewName].align
        );

        const currentInput =
          fileInputs[viewName];

        if (
          currentInput &&
          currentInput.files &&
          currentInput.files.length > 0
        ) {
          renderImageFile(
            currentInput.files[0],
            false
          );
        } else {
          clearPreview();
        }
      }

      if (viewBtns.length > 0) {
        viewBtns.forEach(btn => {
          btn.addEventListener(
            'click',
            e => {
              e.preventDefault();

              viewBtns.forEach(b =>
                b.classList.remove(
                  'is-active'
                )
              );

              btn.classList.add(
                'is-active'
              );

              setView(
                btn.getAttribute(
                  'data-view'
                )
              );
            }
          );
        });
      }

      /* =====================================================
         CARICAMENTO GRAFICA
         ===================================================== */

      function renderImageFile(
        file,
        autoScroll = true
      ) {
        const reader =
          new FileReader();

        reader.onload = function(e) {
          if (uploadedImgPreview) {
            uploadedImgPreview.src =
              e.target.result;
          }

          if (printArea) {
            printArea.classList.add(
              'has-image'
            );
          }

          if (dropzonePreview) {
            dropzonePreview.src =
              e.target.result;

            dropzonePreview.style.display =
              'block';

            if (dropzoneIcon) {
              dropzoneIcon.style.display =
                'none';
            }
          }

          if (removeBtn) {
            removeBtn.style.display =
              'inline-flex';
          }

          if (dropzoneText) {
            dropzoneText.innerHTML =
              'Grafica applicata! <strong>Cambia file</strong>';
          }

          const currentViewBtn =
            viewBtns.find(
              b =>
                b.dataset.view ===
                currentView
            );

          if (currentViewBtn) {
            currentViewBtn.classList.add(
              'has-file'
            );
          }

          recalculatePrice();

          if (autoScroll) {
            const stage =
              section.querySelector(
                '.maviva-top-grid'
              );

            if (stage) {
              const stageRect =
                stage.getBoundingClientRect();

              const offset =
                window.innerWidth > 990
                  ? 120
                  : 80;

              window.scrollBy({
                top:
                  stageRect.top -
                  offset,
                behavior: 'smooth'
              });
            }
          }
        };

        reader.readAsDataURL(file);
      }

      /* =====================================================
         RIMOZIONE GRAFICA
         ===================================================== */

      function clearPreview() {
        if (uploadedImgPreview) {
          uploadedImgPreview.src =
            '';
        }

        if (printArea) {
          printArea.classList.remove(
            'has-image'
          );
        }

        if (dropzonePreview) {
          dropzonePreview.src = '';

          dropzonePreview.style.display =
            'none';

          if (dropzoneIcon) {
            dropzoneIcon.style.display =
              'block';
          }
        }

        if (removeBtn) {
          removeBtn.style.display =
            'none';
        }

        if (dropzoneText) {
          dropzoneText.innerHTML =
            'Trascina o <strong>clicca qui</strong>';
        }

        const currentViewBtn =
          viewBtns.find(
            b =>
              b.dataset.view ===
              currentView
          );

        if (currentViewBtn) {
          currentViewBtn.classList.remove(
            'has-file'
          );
        }

        recalculatePrice();
      }

      /* =====================================================
         DROPZONE
         ===================================================== */

      if (dropzone) {
        dropzone.addEventListener(
          'click',
          () => {
            if (
              fileInputs[currentView]
            ) {
              fileInputs[
                currentView
              ].click();
            }
          }
        );
      }

      Object.values(
        fileInputs
      ).forEach(input => {
        if (!input) return;

        input.addEventListener(
          'change',
          e => {
            if (
              e.target.files &&
              e.target.files.length > 0
            ) {
              renderImageFile(
                e.target.files[0],
                true
              );
            }
          }
        );
      });

      if (removeBtn) {
        removeBtn.addEventListener(
          'click',
          () => {
            if (
              fileInputs[currentView]
            ) {
              fileInputs[
                currentView
              ].value = '';
            }

            clearPreview();
          }
        );
      }

      if (dropzone) {
        [
          'dragenter',
          'dragover',
          'dragleave',
          'drop'
        ].forEach(eventName => {
          dropzone.addEventListener(
            eventName,
            e => {
              e.preventDefault();
              e.stopPropagation();
            },
            false
          );
        });

        [
          'dragenter',
          'dragover'
        ].forEach(eventName => {
          dropzone.addEventListener(
            eventName,
            () =>
              dropzone.classList.add(
                'dragover'
              ),
            false
          );
        });

        [
          'dragleave',
          'drop'
        ].forEach(eventName => {
          dropzone.addEventListener(
            eventName,
            () =>
              dropzone.classList.remove(
                'dragover'
              ),
            false
          );
        });

        dropzone.addEventListener(
          'drop',
          e => {
            const dt =
              e.dataTransfer;

            const files =
              dt.files;

            if (
              files.length > 0 &&
              fileInputs[
                currentView
              ]
            ) {
              fileInputs[
                currentView
              ].files = files;

              renderImageFile(
                files[0],
                true
              );
            }
          }
        );
      }

      /* =====================================================
         INVIO AL CARRELLO SHOPIFY
         ===================================================== */

      if (
        custForm &&
        submitBtn
      ) {
        custForm.addEventListener(
          'submit',
          function(e) {
            e.preventDefault();

            let hasFile = false;

            [
              'front',
              'back',
              'sleeve_l',
              'sleeve_r'
            ].forEach(side => {
              const fInput =
                fileInputs[side];

              const sInput =
                section.querySelector(
                  `.hidden-size-input[data-side="${side}"]`
                );

              const stInput =
                section.querySelector(
                  `.hidden-style-input[data-side="${side}"]`
                );

              if (
                !fInput ||
                !fInput.files ||
                fInput.files.length === 0
              ) {
                if (fInput) {
                  fInput.disabled = true;
                }

                if (sInput) {
                  sInput.disabled = true;
                }

                if (stInput) {
                  stInput.disabled = true;
                }
              } else {
                hasFile = true;
              }
            });

            if (!hasFile) {
              alert(
                'Per favore, carica almeno una grafica prima di aggiungere al carrello.'
              );

              [
                'front',
                'back',
                'sleeve_l',
                'sleeve_r'
              ].forEach(side => {
                if (
                  fileInputs[side]
                ) {
                  fileInputs[
                    side
                  ].disabled =
                    false;
                }

                const sInput =
                  section.querySelector(
                    `.hidden-size-input[data-side="${side}"]`
                  );

                if (sInput) {
                  sInput.disabled =
                    false;
                }

                const stInput =
                  section.querySelector(
                    `.hidden-style-input[data-side="${side}"]`
                  );

                if (stInput) {
                  stInput.disabled =
                    false;
                }
              });

              return false;
            }

            /* Aggiorna variante PRIMA del carrello */

            updateSelectedVariant();

            if (
              !variantIdInput ||
              !variantIdInput.value ||
              (
                selectedVariant &&
                selectedVariant.available ===
                  false
              )
            ) {
              alert(
                "La combinazione colore/taglia selezionata non è disponibile. Scegli un'altra taglia."
              );

              updateCartButtonState();

              return false;
            }

            submitBtn.innerText =
              'Creazione Magia in corso... ⏳';

            submitBtn.disabled =
              true;

            /* =================================================
               CALCOLO SUPPLEMENTI
               ================================================= */

            let supplementQty = 0;
            let activeSidesCount = 0;

            [
              'front',
              'back',
              'sleeve_l',
              'sleeve_r'
            ].forEach(side => {
              const input =
                fileInputs[side];

              if (
                input &&
                input.files &&
                input.files.length > 0
              ) {
                activeSidesCount++;

                const areaId =
                  savedState[
                    side
                  ].areaId;

                const area =
                  areaConfigs.find(
                    a =>
                      a.id ===
                      areaId
                  );

                if (
                  area &&
                  area.surcharge > 0
                ) {
                  supplementQty +=
                    area.surcharge;
                }
              }
            });

            supplementQty +=
              Math.max(
                0,
                activeSidesCount - 1
              );

            /* =================================================
               CREA FORMDATA
               L'INPUT name="id" CONTIENE ORA LA VARIANTE
               COLORE + TAGLIA SELEZIONATA
               ================================================= */

            const formData =
              new FormData(
                custForm
              );

            fetch(
              '/cart/add.js',
              {
                method: 'POST',
                body: formData
              }
            )
              .then(
                async response => {
                  const data =
                    await response.json();

                  if (
                    !response.ok
                  ) {
                    throw new Error(
                      data.description ||
                      data.message ||
                      'Errore durante aggiunta al carrello'
                    );
                  }

                  return data;
                }
              )
              .then(data => {
                /* =============================================
                   SUPPLEMENTO DA 1 €
                   ============================================= */

                if (
                  supplementQty > 0
                ) {
                  fetch(
                    '/cart/add.js',
                    {
                      method:
                        'POST',

                      headers: {
                        'Content-Type':
                          'application/json'
                      },

                      body:
                        JSON.stringify(
                          {
                            items: [
                              {
                                id:
                                  53623886676305,
                                quantity:
                                  supplementQty
                              }
                            ]
                          }
                        )
                    }
                  )
                    .then(() => {
                      window.location.href =
                        '/cart';
                    })
                    .catch(err => {
                      console.error(
                        'Errore aggiunta supplemento:',
                        err
                      );

                      window.location.href =
                        '/cart';
                    });
                } else {
                  window.location.href =
                    '/cart';
                }
              })
              .catch(error => {
                console.error(
                  'Errore aggiunta prodotto principale:',
                  error
                );

                submitBtn.innerText =
                  'Errore. Riprova.';

                submitBtn.disabled =
                  false;
              });
          }
        );
      }

      /* =====================================================
         INIZIALIZZAZIONE TAGLIA
         Prima taglia disponibile selezionata
         ===================================================== */

      if (
        productSizeBtns.length > 0
      ) {
        const initiallyActiveSize =
          productSizeBtns.find(
            btn =>
              btn.classList.contains(
                'is-active'
              )
          ) ||
          productSizeBtns[0];

        productSizeBtns.forEach(
          btn => {
            btn.classList.remove(
              'is-active'
            );

            btn.setAttribute(
              'aria-pressed',
              'false'
            );
          }
        );

        if (
          initiallyActiveSize
        ) {
          initiallyActiveSize.classList.add(
            'is-active'
          );

          initiallyActiveSize.setAttribute(
            'aria-pressed',
            'true'
          );

          selectedProductSize =
            initiallyActiveSize
              .dataset
              .sizeValue || '';

          if (
            productSizeInput
          ) {
            productSizeInput.value =
              selectedProductSize;
          }
        }
      }

      /* =====================================================
         AVVIO
         ===================================================== */

      updateSelectedVariant();

      updateCartButtonState();

      setTimeout(() => {
        setView('front');
      }, 50);

    } catch (err) {
      console.warn(
        'Maviva Customizer Error:',
        err
      );
    }
  });
}

/* =========================================================
   AVVIO SHOPIFY
   ========================================================= */

document.addEventListener(
  'DOMContentLoaded',
  initMavivaCustomizer
);

document.addEventListener(
  'shopify:section:load',
  initMavivaCustomizer
);